import { ScrollView } from "react-native";
import styles from "./styles";
import ProfileNavBar from "../../components/profile/navBar";
import ProfileHeader from "../../components/profile/header";
import ProfilePostList from "../../components/profile/postList";
import { SafeAreaView } from "react-native-safe-area-context";
import { useState, useContext, useEffect } from "react";
import {
  CurrentUserProfileItemInViewContext,
  FeedStackParamList,
} from "../../navigation/feed";
import { useUser } from "../../hooks/useUser";
import { getPostsByUserId } from "../../services/posts";
import { Post } from "../../../types";
import { RouteProp } from "@react-navigation/native";
import { RootStackParamList } from "../../navigation/main";
import { HomeStackParamList } from "../../navigation/home";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import HlsCacheSettings from "../../components/settings/hlsCacheSettings";

type ProfileScreenRouteProp =
  | RouteProp<RootStackParamList, "profileOther">
  | RouteProp<HomeStackParamList, "Me">
  | RouteProp<FeedStackParamList, "feedProfile">;

export default function ProfileScreen({
  route,
}: {
  route: ProfileScreenRouteProp;
}) {
  const initialUserId = route.params?.initialUserId;
  const [userPosts, setUserPosts] = useState<Post[]>([]);
  const currentUser = useSelector((state: RootState) => state.auth.currentUser);

  const providerUserId = useContext(CurrentUserProfileItemInViewContext);
  const targetUserId =
    initialUserId ||
    providerUserId.currentUserProfileItemInView ||
    currentUser?.uid ||
    null;

  const userQuery = useUser(targetUserId);

  const user =
    userQuery.data ||
    (currentUser?.uid === targetUserId ? currentUser : null);

  useEffect(() => {
    if (!user) {
      return;
    }

    getPostsByUserId(user.uid)
      .then((posts) => setUserPosts(posts))
      .catch((error) => {
        console.warn("User posts unavailable:", error);
      });
  }, [user?.uid]);

  if (!user) {
    return <></>;
  }

  return (
    <SafeAreaView style={styles.container}>
      <ProfileNavBar user={user} />
      <ScrollView>
        <ProfileHeader user={user} />
        {currentUser?.uid === user.uid && <HlsCacheSettings />}
        <ProfilePostList posts={userPosts} />
      </ScrollView>
    </SafeAreaView>
  );
}
